import React from 'react';
import { Link } from 'react-router-dom';
import { NamedLink } from '../NamedLink/NamedLink';

import css from './BackNavigation.module.css';

const BackNavigation = ({ className, label = 'Back', name, params, to }) => {
  const content = <><span className={css.arrow} aria-hidden="true">&#8592;</span>{label}</>;
  const rootClassName = className ? `${css.root} ${className}` : css.root;

  return name ? (
    <NamedLink className={rootClassName} name={name} params={params} to={to}>
      {content}
    </NamedLink>
  ) : (
    <Link className={rootClassName} to={to}>
      {content}
    </Link>
  );
};

export default BackNavigation;
